// STYD: kortingscode toepassen of verwijderen in de side cart en op de winkelwagenpagina.
// Gebruikt /cart/update met `discount` en tekent daarna de winkelwagen opnieuw (snippets/styd-cart-discount.liquid).
if (!customElements.get('styd-cart-discount')) {
  customElements.define(
    'styd-cart-discount',
    class StydCartDiscount extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.styd-cart-discount__input');
        this.applyButton = this.querySelector('.styd-cart-discount__apply');

        this.applyButton?.addEventListener('click', () => this.apply());
        this.input?.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter') return;
          event.preventDefault();
          this.apply();
        });
        this.querySelectorAll('[data-remove-code]').forEach((button) => {
          button.addEventListener('click', () => this.remove(button.dataset.removeCode));
        });
      }

      currentCodes() {
        try {
          return JSON.parse(this.dataset.codes || '[]');
        } catch (error) {
          return [];
        }
      }

      apply() {
        const code = this.input.value.trim();
        if (!code) return;
        const codes = this.currentCodes().filter((existing) => existing.toLowerCase() !== code.toLowerCase());
        this.update([...codes, code]);
      }

      remove(code) {
        this.update(this.currentCodes().filter((existing) => existing !== code));
      }

      sectionsToRender() {
        if (this.closest('cart-drawer')) {
          return [
            { section: 'cart-drawer', target: '#CartDrawer', selector: '#CartDrawer' },
            { section: 'cart-icon-bubble', target: '#cart-icon-bubble', selector: '.shopify-section' },
          ];
        }
        const items = document.getElementById('main-cart-items');
        const footer = document.getElementById('main-cart-footer');
        return [
          items && { section: items.dataset.id, target: '#main-cart-items .js-contents', selector: '.js-contents' },
          footer && { section: footer.dataset.id, target: '#main-cart-footer .js-contents', selector: '.js-contents' },
          { section: 'cart-icon-bubble', target: '#cart-icon-bubble', selector: '.shopify-section' },
        ].filter(Boolean);
      }

      update(codes) {
        const sections = this.sectionsToRender();
        this.setAttribute('aria-busy', 'true');
        if (this.applyButton) this.applyButton.disabled = true;

        fetch(`${routes.cart_update_url}`, {
          ...fetchConfig(),
          body: JSON.stringify({
            discount: codes.join(','),
            sections: sections.map((item) => item.section),
            sections_url: window.location.pathname,
          }),
        })
          .then((response) => response.json())
          .then((state) => {
            if (!state.sections) return;
            const drawer = this.closest('cart-drawer');
            sections.forEach((item) => {
              const html = state.sections[item.section];
              const target = document.querySelector(item.target);
              if (!html || !target) return;
              const source = new DOMParser().parseFromString(html, 'text/html').querySelector(item.selector);
              if (source) target.innerHTML = source.innerHTML;
            });
            if (drawer) {
              drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', drawer.close.bind(drawer));
            }
          })
          .catch((error) => console.error(error))
          .finally(() => {
            this.removeAttribute('aria-busy');
            if (this.applyButton) this.applyButton.disabled = false;
          });
      }
    }
  );
}
